import tr from './tr/index';

export default {
  tr,
};
